import React, { useCallback, useEffect, useState } from 'react';
import TooltipLabel from './subcomponents/TooltipLabel';
import DualChoiceButtons from './subcomponents/DualChoiceButtons';
import FormBoxDropdown from './subcomponents/FormBoxDropdown';
import { demoState } from '../states/DemoState';
import { useRecoilValue } from 'recoil';
import { sellerTypeList, companyTypeList } from '../helpers/lists';
import { Profile } from '../model/model';
import CustomDropdown from './subcomponents/CustomDropdown';
import { companyTypeInfo, sellerTypeInfo, subscriptionInfo, vatPayerInfo } from '../helpers/tooltips';
import { styled } from 'styled-components';

const Title = styled.span`
    font-family: 'Grold', sans-serif;
    font-size: 1rem;
    font-weight: 800;
`;

const CompanyProfileContainer = styled.div`
    width: 100%;
    display: grid;
    padding: 1rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1rem;
`;

const CompanyProfileItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

interface CompanyProfileProps {
    profile: Profile;
    onProfileChange: (profile: Profile) => void;
}

const CompanyProfile: React.FC<CompanyProfileProps> = ({ profile, onProfileChange }) => {
    const [sellersType, setSellersType] = useState<number>(profile.sellersType);
    const [vatPayer, setVatPayer] = useState<boolean>(profile.vatPayer);
    const [companyType, setCompanyType] = useState<number>(profile.companyType);
    const [subscription, setSubscription] = useState<boolean>(profile.subscription);
    const demo = useRecoilValue(demoState);

    const handleProfileChange = useCallback(() => {
        onProfileChange({
            sellersType,
            vatPayer,
            companyType,
            subscription,
        });
    }, [sellersType, vatPayer, companyType, subscription]);

    useEffect(() => {
        handleProfileChange();
    }, [sellersType, vatPayer, companyType, subscription]);

    return (
        <>
            <Title>KROK 1 - PROFIL TWOJEJ FIRMY</Title>
            <FormBoxDropdown variant="standard" headerContent="DANE">
                <CompanyProfileContainer>
                    <CompanyProfileItem>
                        <TooltipLabel label="Rodzaj sprzedawcy" tooltip={sellerTypeInfo} />
                        <DualChoiceButtons
                            option1={sellerTypeList[0].label}
                            option2={sellerTypeList[1].label}
                            defaultOption={profile.sellersType === sellerTypeList[0].value ? sellerTypeList[0].label : sellerTypeList[1].label}
                            onSelectionChange={(selectedOption) => {
                                setSellersType(sellerTypeList.find(item => item.label === selectedOption)?.value || 0);
                            }}
                            disabled={demo}
                        />
                    </CompanyProfileItem>
                    <CompanyProfileItem>
                        <TooltipLabel label="Rodzaj działalności gospodarczej" tooltip={companyTypeInfo} />
                        <CustomDropdown
                            options={companyTypeList}
                            defaultValue={profile.companyType}
                            onChange={(value: number) => {
                                setCompanyType(value);
                            }}
                            disabled={demo}
                        />
                    </CompanyProfileItem>
                    <CompanyProfileItem>
                        <TooltipLabel label="Podatnik" tooltip={vatPayerInfo} />
                        <DualChoiceButtons
                            option1="Podatnik Vat"
                            option2="Zwolniony"
                            defaultOption={profile.vatPayer ? "Podatnik Vat" : "Zwolniony"}
                            onSelectionChange={(selectedOption) => {
                                setVatPayer(selectedOption === "Podatnik Vat");
                            }}
                            disabled={demo}
                        />
                    </CompanyProfileItem>
                    <CompanyProfileItem>
                        <TooltipLabel label="Abonament Allegro" tooltip={subscriptionInfo} />
                        <DualChoiceButtons
                            option1="Tak"
                            option2="Nie"
                            defaultOption={profile.subscription ? "Tak" : "Nie"}
                            onSelectionChange={(selectedOption) => {
                                setSubscription(selectedOption === "Tak");
                            }}
                            disabled={demo}
                        />
                    </CompanyProfileItem>
                </CompanyProfileContainer>
            </FormBoxDropdown>
        </>
    );
};

export default CompanyProfile;